export default __webpack_public_path__ + "static/media/2021Sale.ec03c848.png";